import { loadSettings } from "./settingActions";
import {
  register as registerSIP,
  unregister as unregisterSIP,
  getUserAgentOptions,
  updateRegisteredEndpoint,
} from "./sipActions";
import Storage from "../misc/storage";
import * as ActionTypes from "../actions/actionTypes";
import { loginSuccess } from "../actions/configActions";
import { detectLocalIpAddress2 } from "../misc/localIpAddress";
import UserService from "../services/userService";
import MmxApi from "../api/mmxApi";

export function initUser(user, systemConfig) {
  return (dispatch, getstate) => {
    if (!user && Storage.session.get("user")) {
      user = JSON.parse(Storage.session.get("user"));
    }
    if (!systemConfig && Storage.session.get("systemConfig")) {
      systemConfig = JSON.parse(Storage.session.get("systemConfig"));
    }

    if (systemConfig) {
      dispatch({
        type: ActionTypes.CONFIG_SYSTEM_LOADED,
        payload: {
          systemConfig: systemConfig,
          config: getstate().config,
        },
      });
    }
    if (user) {
      dispatch(loginSuccess(user));
      dispatch(loadSettings());
    }
    if (systemConfig && user) {
      dispatch(
        requireMedia(
          getstate().config.mode.audio,
          getstate().config.mode.video,
          systemConfig,
          user,
          dispatch
        )
      );
    }
    if (!user && getstate().config.mode.anonymous_autologin) {
      dispatch(
        login(
          getstate().config.anonymous.user,
          getstate().config.anonymous.password
        )
      );
    }

    dispatch({
      type: ActionTypes.CONFIG_INIT_COMPLETED,
      payload: {},
    });
  };
}

export function requireMedia(audio, video, systemConfig, user, dispatch) {
  return (dispatch, getstate) => {
    if (
      getstate().config.webrtc === false &&
      getstate().config.temasys === false
    ) {
      dispatch({
        type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
        payload: {
          audio: false,
          video: false,
        },
      });

      dispatch(
        registerSIP(getUserAgentOptions(user, systemConfig, getstate, dispatch))
      );
      return;
    }

    dispatch({
      type: ActionTypes.CONFIG_REQUIREMEDIA_STARTED,
      payload: {
        audio: false,
        video: false,
      },
    });

    var listDevices = { video: false, audio: false };
    var environment = global.window || global;
    environment.navigator.mediaDevices
      .enumerateDevices()
      .then(function(devices) {
        devices.forEach(function(device) {
          if (device.kind.indexOf("videoinput") !== -1 && video)
            listDevices.video = true;
          if (device.kind.indexOf("audioinput") !== -1 && audio)
            listDevices.audio = true;
        });
        dispatch({
          type: ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS,
          payload: {
            audio: listDevices.audio,
            video: listDevices.video,
          },
        });
      })
      .catch(function(err) {
        console.log(err.name + ": " + err.message);
      });

    detectLocalIpAddress2().then(localIpAddress => {
      dispatch(localIpAquired(localIpAddress));
    });
    dispatch(
      registerSIP(getUserAgentOptions(user, systemConfig, getstate, dispatch))
    );
  };
}

export function refreshProperties() {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;
    if (securityToken) {
      UserService.getUserProperties(
        getstate().config.server,
        securityToken,
        dispatch
      )
        .done(data => {
          var properties = {};
          data.propertySet.forEach(function(element) {
            properties[element.key] = element.value;
          }, this);

          var user = {
            ...getstate().user,
            properties: properties,
          };

          Storage.session.set("user", JSON.stringify(user));

          dispatch(initUser());
          dispatch({
            type: "USER_REFRESH",
            payload: { user: user },
          });
        })
        .fail(() => {
          console.warn("Could not get properties for user from server");
        });
    }
  };
}

export function login(username, password) {
  return (dispatch, getstate) => {
    const api = new MmxApi(
      getstate().config.server,
      null,
      dispatch,
      getstate().network.serverError
    );
    const params = {
      username: username,
      password: password,
      force: true,
      willUseSipRegistration: true,
    };

    api.user
      .login(params)
      .done(data => {
        var systemConfig = {};
        var properties = { sipAddress: data.properties.sipAddress };
        data.properties.propertySet.forEach(function(element) {
          properties[element.key] = element.value;
        }, this);
        data.capabilities.forEach(function(element) {
          systemConfig[element.key] = element.value;
        }, this);

        var user = {
          properties: { ...properties },
          authenticated: true,
          username: username,
          password: password,
          securityToken: data.securityToken,
          uri: data.uri,
          anonymous:
            getstate().config.anonymous &&
            username === getstate().config.anonymous.user,
        };

        Storage.session.set("user", JSON.stringify(user));
        Storage.session.set("systemConfig", JSON.stringify(systemConfig));
        dispatch(initUser(user, systemConfig));
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        var data =
          xhr.responseText && xhr.status !== 404
            ? JSON.parse(xhr.responseText)
            : {};
        console.error(xhr);
        console.error(
          "Error when login against " +
            getstate().config.server +
            "/userApi/user/api/user/login"
        );

        Storage.session.set("user", null);

        var error =
          getstate().config.text("error.unknown") + " " + data.errorCode;
        switch (data.errorCode) {
          case -7:
            error = getstate().config.text("error.accountexpired");
            break;
          case -1:
            error = getstate().config.text("error.usernameorpassword");
            break;
          default:
            break;
        }
        dispatch(loginFailed(error));
      });
  };
}

export function validate1(username, password) {
  return (dispatch, getstate) => {
    var action = {
      type: "USER_LOGINFORM_VALIDATE",
      payload: {
        loginform: {
          usernameValid: username ? true : false,
          passwordValid: password ? true : false,
          valid: username && password,
        },
      },
    };
    dispatch(action);
  };
}

export function logout() {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;
    UserService.logout(getstate().config.server, securityToken, dispatch)
      .done(data => {
        dispatch(logoutSuccess());
        dispatch(unregisterSIP());
        dispatch(updateRegisteredEndpoint(0));
        Storage.session.set("sessionid", null);
        Storage.session.set("user", null);
        Storage.session.set("systemConfig", null);
        Storage.local.set("settings", null);
        localStorage.setItem("logout-event", "logout" + Math.random());
      })
      .fail(() => {
        console.warn("Could not log out from server");
      });
  };
}

export function localLogout() {
  return (dispatch, getstate) => {
    dispatch(logoutSuccess());
    dispatch(unregisterSIP());
    dispatch(updateRegisteredEndpoint(0));
    Storage.session.set("sessionid", null);
    Storage.session.set("user", null);
    Storage.session.set("systemConfig", null);
    Storage.local.set("settings", null);
    localStorage.setItem("logout-event", "logout" + Math.random());
  };
}

export const localIpAquired = localIp => ({
  type: ActionTypes.LOCAL_IP_AQUIRED,
  ip: localIp,
});

function logoutSuccess() {
  return {
    type: ActionTypes.USER_LOGOUT_SUCCESS,
  };
}

function loginFailed(error) {
  return {
    type: ActionTypes.USER_LOGIN_FAILED,
    payload: {
      loginerror: error,
    },
  };
}






// WEBPACK FOOTER //
// ./src/actions/userActions.js